'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var palette = _ref.palette;

  var getTooltipProps = function getTooltipProps(appearance) {
    switch (appearance) {
      case 'card':
        return {
          backgroundColor: 'white',
          elevation: 3
        };
      case 'default':
      default:
        return {
          color: 'white',
          backgroundColor: (0, _tinycolor2.default)(palette.neutral.base).setAlpha(0.95).toString()
        };
    }
  };

  return getTooltipProps;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2UvZ2V0VG9vbHRpcFByb3BzLmpzIl0sIm5hbWVzIjpbInBhbGV0dGUiLCJnZXRUb29sdGlwUHJvcHMiLCJhcHBlYXJhbmNlIiwiYmFja2dyb3VuZENvbG9yIiwiZWxldmF0aW9uIiwiY29sb3IiLCJuZXV0cmFsIiwiYmFzZSIsInNldEFscGhhIiwidG9TdHJpbmciXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOzs7Ozs7a0JBRWUsZ0JBQWlCO0FBQUEsTUFBZEEsT0FBYyxRQUFkQSxPQUFjOztBQUM5QixNQUFNQyxrQkFBa0IsU0FBbEJBLGVBQWtCLGFBQWM7QUFDcEMsWUFBUUMsVUFBUjtBQUNFLFdBQUssTUFBTDtBQUNFLGVBQU87QUFDTEMsMkJBQWlCLE9BRFo7QUFFTEMscUJBQVc7QUFGTixTQUFQO0FBSUYsV0FBSyxTQUFMO0FBQ0E7QUFDRSxlQUFPO0FBQ0xDLGlCQUFPLE9BREY7QUFFTEYsMkJBQWlCLHlCQUFVSCxRQUFRTSxPQUFSLENBQWdCQyxJQUExQixFQUNkQyxRQURjLENBQ0wsSUFESyxFQUVkQyxRQUZjO0FBRlosU0FBUDtBQVJKO0FBZUQsR0FoQkQ7O0FBa0JBLFNBQU9SLGVBQVA7QUFDRCxDIiwiZmlsZSI6ImdldFRvb2x0aXBQcm9wcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0aW55Y29sb3IgZnJvbSAndGlueWNvbG9yMidcblxuZXhwb3J0IGRlZmF1bHQgKHsgcGFsZXR0ZSB9KSA9PiB7XG4gIGNvbnN0IGdldFRvb2x0aXBQcm9wcyA9IGFwcGVhcmFuY2UgPT4ge1xuICAgIHN3aXRjaCAoYXBwZWFyYW5jZSkge1xuICAgICAgY2FzZSAnY2FyZCc6XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiAnd2hpdGUnLFxuICAgICAgICAgIGVsZXZhdGlvbjogM1xuICAgICAgICB9XG4gICAgICBjYXNlICdkZWZhdWx0JzpcbiAgICAgIGRlZmF1bHQ6XG4gICAgICAgIHJldHVybiB7XG4gICAgICAgICAgY29sb3I6ICd3aGl0ZScsXG4gICAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aW55Y29sb3IocGFsZXR0ZS5uZXV0cmFsLmJhc2UpXG4gICAgICAgICAgICAuc2V0QWxwaGEoMC45NSlcbiAgICAgICAgICAgIC50b1N0cmluZygpXG4gICAgICAgIH1cbiAgICB9XG4gIH1cblxuICByZXR1cm4gZ2V0VG9vbHRpcFByb3BzXG59XG4iXX0=